<template>
  <Popup v-model:show="popupShow" title="驳回" height="70%" :round="true">
    <div class="h-full bg-white px-15">
      <div class="text-16 text-default h-50 leading-50">原因描述<i class="text-required">*</i></div>
      <van-field
        class="rounded-2 text-14"
        style="border:1px solid #E1E3E5"
        v-model="opt_content"
        rows="4"
        type="textarea"
        maxlength="200"
        placeholder="请填写驳回原因"
      />
    </div>
    <FooterButton okText="提交" :showCancel="false" @submit="handleSubmit" />
  </Popup>
</template>
<script setup>
import Popup from "@/components/PopupPicker/Popup.vue";
import { useVModel } from "@vueuse/core";
import { FooterButton } from "@/components/FormView/index";
import { ref } from "vue";
import { repairService } from "@/service";
import { useRoute } from "vue-router";
import { Toast } from "vant";
import to from "await-to-js";
import { vLoading } from "@/utils/loading";

const route = useRoute();

const props = defineProps({
  modelValue: { default: false },
  list: { default: () => [] }
});

const emit = defineEmits(["update:modelValue", "refresh"]);

const popupShow = useVModel(props, "modelValue", emit);

const opt_content = ref("");

const handleSubmit = async () => {
  if (!opt_content.value) return Toast.fail("必填项不可为空");
  vLoading.start();
  const [err] = await to(
    repairService.faultConfirm({
      workorder_id: route.query.id,
      confirm_state: 2,
      fault_confirm_notes: opt_content.value
    })
  );
  vLoading.stop();

  if (err) return;

  Toast.success("驳回成功！");

  popupShow.value = false;

  emit("refresh");
};
</script>
